export const FAQS_URL =
  'https://docs.helixpay.ph/docs/frequently-asked-questions-faqs';

export const CONSOLE_DOCS_URL = 'https://docs.helixpay.ph/docs/events';

export const EVENTS_DOCS_URL = 'https://docs.helixpay.ph/docs/events';

export const SIGN_UP_URL =
  'https://form.jotform.com/HelixPay_PH/helixpay-sign-up-form';
